import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { RootState } from '../redux/store';

const useTranslate = (lang?: string) => {
    const { t } = useTranslation();
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const activeLanguage = lang ?? language;

    const translate = useCallback(
        (value: string) => t(value, { lng: activeLanguage }),
        [t, activeLanguage]
    );
    return { language: activeLanguage, translate };
};

export default useTranslate;
